import { useRef } from 'react';
import { useTexts } from './TextsContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Editable({ id, placeholder, className = '' }) {
  const ref = useRef(null);
  const { texts, ready, canEdit } = useTexts();
  const initial = texts[id] || placeholder;

  if (!ready || !canEdit) {
    return (
      <span className={className} data-testid={`editable-${id}`}>
        {ready ? initial : placeholder}
      </span>
    );
  }

  const onFocus = () => {
    if (ref.current.textContent.trim() === placeholder.trim()) {
      const range = document.createRange();
      range.selectNodeContents(ref.current);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
  };

  const onBlur = () => {
    const text = ref.current.textContent.trim();
    try {
      localStorage.setItem(`invite.${id}`, text);
    } catch (e) {}
    fetch(`${API}/texts/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text }),
    }).catch(() => {});
  };

  return (
    <span
      ref={ref}
      role="textbox"
      tabIndex={0}
      data-testid={`editable-${id}`}
      className={className}
      contentEditable
      suppressContentEditableWarning
      spellCheck={false}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {initial}
    </span>
  );
}
